import { Control, Controller } from "react-hook-form";
import { useTranslations } from "@jugl-web/utils";
import { Segment } from "@jugl-web/ui-components/cross-platform/forms/Segment";
import { useInventoryFormOptions } from "@jugl-web/domain-resources/inventory/hooks/useInventoryFormOptions";
import { ServiceFormValues } from "../../types";

interface ComponentProps {
  control: Control<ServiceFormValues>;
}

export const CategoryField = ({ control }: ComponentProps) => {
  const { t } = useTranslations();

  const { categories } = useInventoryFormOptions();

  return (
    <Controller
      control={control}
      name="category"
      render={({ field: { value, onChange } }) => (
        <Segment
          label={t({
            id: "inventory-item-form-page.category",
            defaultMessage: "Category",
          })}
          isRequired
          selectedItem={value}
          onChange={onChange}
          items={categories.map((category) => ({
            id: category.value,
            title: category.label,
          }))}
        />
      )}
    />
  );
};
